module.exports = __webpack_public_path__ + "img/home_news_3.715c1606.png";